{
  "$schema": "http://json-schema.org/draft-07/schema",
  "$id": "ContactRelationshipDefinition",
  "definitions": {
    "ContactRelationshipSchema": {
      "type": "object",
      "required": [
        "id",
        "created_by",
        "created_at",
        "deleted_by",
        "deleted_at",
        "subject_id",
        "contact_id",
        "relationship",
        "profile_id"
      ],
      "additionalProperties": false,
      "properties": {
        "id": {
          "type": "string",
          "format": "uuid"
        },
        "created_by": {
          "type": "string"
        },
        "created_at": {
          "type": "string",
          "format": "date-time"
        },
        "deleted_by": {
          "type": ["string", "null"],
          "format": "uuid"
        },
        "deleted_at": {
          "type": ["string", "null"],
          "format": "date-time"
        },
        "subject_id": {
          "description": "The origin contact. The contactId will have the relationship with this contact.",
          "type": "string"
        },
        "contact_id": {
          "type": "string",
          "not": {
            "enum": ["create"]
          }
        },
        "relationship": {
          "type": "string",
          "enum": ["student", "parent", "carer", "unknown"]
        },
        "contact_user_id": {
          "type": ["string", "null"]
        },
        "profile_id": {
          "type": "string"
        }
      }
    }
  }
}
